import { Button, Tabs } from 'antd';
import { ClassroomForum } from './components/Forum/ClassroomForum';
import { ClassroomShowInfo } from './components/ClassroomShowInfo';
import { CreateTopicModal } from 'components/modal/forum/CreateTopicModal';
import {
  EditButton,
  ListButton,
  RefreshButton,
  Show,
  useModal
} from '@refinedev/antd';
import { IClassroom } from 'interfaces/classrooms';
import { PlusSquareOutlined } from '@ant-design/icons';
import { getTenant } from 'services/tenants';
import { useShow } from '@refinedev/core';
import { useState } from 'react';

export const ClassroomShow = () => {
  const tenant = getTenant();
  const [activeTab, setActiveTab] = useState('info');
  const { queryResult } = useShow<IClassroom>();
  const { data, isLoading } = queryResult;
  const record = data?.data;

  const {
    show: topicCreateModalShow,
    close: topicCreateModalClose,
    modalProps: topicCreateModalProps
  } = useModal();

  return (
    <Show
      isLoading={isLoading}
      title="Visualizar turma"
      headerButtons={
        <>
          <ListButton />
          {activeTab !== 'forum' ? (
            <>
              <EditButton />
              <RefreshButton />
            </>
          ) : (
            <Button
              icon={<PlusSquareOutlined />}
              type="default"
              onClick={topicCreateModalShow}
            >
              Novo Tópico
            </Button>
          )}
        </>
      }
    >
      <Tabs
        onChange={activeKey => setActiveTab(activeKey)}
        defaultActiveKey={activeTab}
      >
        <Tabs.TabPane tab="Informações gerais" key="info">
          {record && <ClassroomShowInfo classroom={record} />}
        </Tabs.TabPane>
        {!tenant.disabledFeatures?.includes('forums') && (
          <Tabs.TabPane tab="Fóruns" key="forum">
            <ClassroomForum />
          </Tabs.TabPane>
        )}
      </Tabs>
      <CreateTopicModal
        kind="Classroom"
        parent={record}
        modalProps={topicCreateModalProps}
        modalClose={topicCreateModalClose}
      />
    </Show>
  );
};
